import styled from 'styled-components';
import {
  colorText,
  colorTextAdditional,
  colorFieldsBorder,
  colorRedNew,
  colorStatusActive,
  colorGreen,
  colorSwitchActive,
} from '../../../utils/palette';

export const SectionLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  color: ${colorTextAdditional};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
`;

export const SectionDesc = styled.p`
  font-size: 11px;
  color: ${colorTextAdditional};
  margin: 0 0 14px 0;
  line-height: 1.4;
`;

export const CountRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const CountLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${colorText};
`;

export const CountBadge = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${({ $atMax }) => ($atMax ? '#fff' : colorText)};
  background: ${({ $atMax }) => ($atMax ? colorSwitchActive : colorFieldsBorder)};
  padding: 2px 10px;
  border-radius: 10px;
`;
